app:
<template>
  <div id="app">
    <!-- Renderiza o Layout apenas se não estiver na página de login -->
    <Layout v-if="isLayoutPage">
      <AppHeader />
      <router-view />
    </Layout>
    <!-- Renderiza diretamente o conteúdo para a página de login -->
    <router-view v-else />
  </div>
</template>

<script>
import Layout from "./components/Layout.vue";
import AppHeader from "./components/Navigation/Header.vue";

export default {
  name: "App",
  components: {
    Layout,
    AppHeader,
  },
  computed: {
    // Verifica se está na rota de login
    isLayoutPage() {
      return this.$route.name !== "login" && !this.$route.meta?.standalone;
    },
  },
};
</script>

<style></style>
